/**
 * Owner: Masa Bayu
 * File: Button.tsx
 * Date:Time: 2026-09-17 22:23
 * Description: UI-01 Button — token-driven action primitive.
 */

import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type QxButtonVariant = 'primary' | 'secondary' | 'ghost' | 'accent';

export interface QxButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: QxButtonVariant;
  readonly children: ReactNode;
}

export function QxButton({
  variant = 'primary',
  className,
  type = 'button',
  children,
  ...rest
}: QxButtonProps) {
  const classes = ['qx-btn', `qx-btn--${variant}`, className].filter(Boolean).join(' ');
  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}
